/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-betting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.47
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TournamentRoundType = {
    Node: 'node',
    Leaf: 'leaf'
} as const;
export type TournamentRoundType = typeof TournamentRoundType[keyof typeof TournamentRoundType];


export function instanceOfTournamentRoundType(value: any): boolean {
    for (const key in TournamentRoundType) {
        if (Object.prototype.hasOwnProperty.call(TournamentRoundType, key)) {
            if (TournamentRoundType[key as keyof typeof TournamentRoundType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TournamentRoundTypeFromJSON(json: any): TournamentRoundType {
    return TournamentRoundTypeFromJSONTyped(json, false);
}

export function TournamentRoundTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentRoundType {
    return json as TournamentRoundType;
}

export function TournamentRoundTypeToJSON(value?: TournamentRoundType | null): any {
    return value as any;
}

